import React, { Component } from 'react';
import Field from '../../../../common/form/Field';

class ClassDropdownField extends Component {
  render() {
    const { name, label, form } = this.props;
    
    return (
      <Field
        name={name}
        label={label}
        required={true}
        fieldDropdownType="classification"
        form={form}
      />
    );
  }
}


export default ClassDropdownField;
